import React from "react";
import loader from "../images/SupervityBlackIcon.gif";
function Loader(props) {
  return (
    <div className="empty-skill">
      {/* <img src={loader} alt="" style={{ ...props.styles }} /> */}
      <img src={loader} alt="loader" style={{width: '250px' }} />
      <p>{props.message}</p>
    </div>
  );
}

export default Loader;
